
<template>
  <div class="container mt-12 pb-10">
    <d-table class="mt-10" :data="data" :loading="loadingData" detailed paginated backend-pagination :total="total" backend-search backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" striped detail-key="id" default-sort-direction="desc" show-search show-filter :per-page="pagination.pageSize" :search.sync="filter" @page-change="page => pagination.page = page" @sort="onSort">
      <template #action-buttons>
        <h1 class="text-primary-500 mr-3">
          Test Sections
        </h1>
      </template>
      <template #action-buttons-right>
        <div class="flex">
          <d-button :loading="loadingReport" @click.native="getTestSectionsReport">
            Export Test Questions
          </d-button>
        </div>
      </template>
      <template slot-scope="props">
        <d-table-column field="code" :row="props.row" label="Code" sortable>
          {{ props.row.code }}
        </d-table-column>
        <d-table-column field="name" :row="props.row" label="Name" sortable>
          {{ props.row.name }}
        </d-table-column>
      </template>
      <template slot="detail" slot-scope="props">
        <test-questions-table-component :test-section-id="props.row.id" />
      </template>
    </d-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import TestQuestionsTableComponent from './components/TestQuestionsTableComponent';

  export default {
    parent: true,
    components: {
      TestQuestionsTableComponent,
    },
    data: () => ({
      sectionId: '',
      data: [],
      loadingData: false,
      loadingReport: false,
      total: 0,
      filter: '',
      pagination: {
        page: 1,
        pageSize: 50,
        sortField: 'name',
        sortOrder: 'asc',
      },
    }),

    watch: {
      pagination: {
        handler() {
          this.getTestSectionsPaged();
        },
        deep: true,
      },
      filter() {
        this.getTestSectionsPaged();
      },
    },
    mounted() {
      this.sectionId = this.$attrs.sectionId;
      this.getTestSectionsPaged();
    },
    methods: {
      async getTestSectionsPaged() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`, `filter=${this.filter}`, `sectionType=${this.sectionId}`].join('&');

        this.loadingData = true;
        const { data } = await axios.get(`/api/testSections/paged?${params}`);
        this.data = data.resultItems;
        this.loadingData = false;
      },

      async getTestSectionsReport() {
        try {
          this.loadingReport = true;
          const { data } = await axios.get('/api/exports/test-sections', {
            responseType: 'blob',
          });
          if (!window.navigator.msSaveOrOpenBlob) {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'export.xlsx');
            document.body.appendChild(link);
            link.click();
            this.loadingReport = false;
          } else {
            // BLOB FOR EXPLORER 11
            window.navigator.msSaveOrOpenBlob(new Blob([data]), 'export.xlsx');
            this.loadingReport = false;
          }
        } catch (error) {
          this.$toast.error({ message: error.response.data[0] });
          this.loadingReport = false;
        }
      },

      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },
    },

  };
</script>